import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {getStatuses, resetUpdateUserStatus, updateStatus} from "../../store/reducers/UsersSlice";
import {getOfflineReasons} from "../../store/reducers/OfflineReasonsSlice";
import {Option} from "../common/form/ElogSelect";
import {useLocation} from "react-router-dom";

interface UserStatusScreenProps {
}

export const UserStatusScreen: React.FC<UserStatusScreenProps> = () => {

    const dispatch = useAppDispatch();
    const location = useLocation();

    const usersState = useAppSelector(state => state.users);
    const offlineReasonsState = useAppSelector(state => state.offlineReasons);

    useEffect(() => {
        dispatch(getOfflineReasons());
        dispatch(getStatuses());
    }, []);

    useEffect(() => {
        dispatch(resetUpdateUserStatus());
    }, [location]);

    const handleStatusChange = (value: string, userId: number) => {
        dispatch(updateStatus({ id: String(userId), userData: { reason: value } }));
        setTimeout(() => {
            dispatch(getStatuses());
        },20)
    }

    return (
        <LoggedInView fullWidth={false}>
            <h1>Staatused</h1>
            <table className="data">
                <thead>
                <tr>
                    <th className="left" style={{width:'160px'}}>Logistik</th>
                    <th className="left" style={{width:'20px'}}></th>
                    <th className="left">Põhjus</th>
                </tr>
                </thead>
                <tbody>
                {usersState.statuses.map(user => (
                    <tr>
                        <td>{user.firstname}</td>
                        <td>
                            {user.offline === 1 && <img id="indicator_11"
                                                        src={process.env.PUBLIC_URL + '/gfx/ico_red_bullet.png'} />}
                            {user.offline === 0 && <img id="indicator_11"
                                                        src={process.env.PUBLIC_URL + '/gfx/ico_green_bullet.png'} />}
                        </td>
                        <td className="left">
                            <select className="change_status" onChange={(e) => handleStatusChange(e.target.value, user.id)}>
                                <option value="0" selected={user.offline === 0}>Jaotuses</option>
                                {offlineReasonsState.offlineReasons.map(reason => (
                                    <option key={reason.id} value={String(reason.id)} selected={user.offline === 1 && user?.offline_time?.offline_reason_id === reason.id}>{reason.name}</option>
                                ))}
                            </select>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </LoggedInView>
    )

}